// extracted by mini-css-extract-plugin
export default {"CardTile":"CardTile_CardTile__Cvu3Y","card-img":"CardTile_card-img__cuCWP"};